module.exports = __webpack_public_path__ + "static/media/Trail_Winds_ByLaws.f6de5a29.pdf";